import template from './insurance-list.html';
import controller from './insurance-list.controller';

let insuranceListComponent = {
  bindings: {},
  template,
  controller
};

export default insuranceListComponent;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance-list.component.js